import { render, staticRenderFns } from "./PaymentStatusBadge.vue?vue&type=template&id=b46c6d18&"
import script from "./PaymentStatusBadge.vue?vue&type=script&lang=ts&"
export * from "./PaymentStatusBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports